// extracted by mini-css-extract-plugin
export default {"banner":"_1RK5UVeCSPaQKgV5B_YlmC","link":"_3eWzD7QhVFcFv1b-zzDY-0","dismissButton":"_16xCXaDy2I6df3UXMLyMpj","dismissed":"cnyGUEfDVM3LdPk4a4BF8","animate":"Hs819Mi-bvxgdSkYdjKR_"};